import { render } from "./TestProgress.vue?vue&type=template&id=4bb79800&scoped=true&ts=true"
import script from "./TestProgress.vue?vue&type=script&lang=ts"
export * from "./TestProgress.vue?vue&type=script&lang=ts"

import "./TestProgress.vue?vue&type=style&index=0&id=4bb79800&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb79800"]])

export default __exports__